import type {BettingType} from "./betting-type";

export type {BettingType};

export const BettingTypesMap: Record<number, BettingType> = {
    1881: {
        id: 1881,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        name: 'Ganyan - Sabit ihtimalli',
        prefix: 'GNY',
        info: 'Bir koşunun birincisini tahmin ederek o at üzerinde oynanan bahistir. Ganyan - Sabit ihtimalli bahis türünde kupon iptal edilemez ve eküri kuralları geçerli değildir.',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isFob: true,
        isSelectable: true,
    },
    1882: {
        id: 1882,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        name: 'Ganyan - Kapanış Oranı',
        info: 'Bir koşunun birincisini tahmin ederek o at üzerinde oynanan bahistir. Ganyan - Sabit ihtimalli bahis türünde kupon iptal edilemez ve eküri kuralları geçerli değildir.',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isFob: true,
        isClosingOdds: true,
    },
    1883: {
        id: 1883,
        available: true,
        column: 4,
        subType: 4,
        columnLabel: 'Koşu',
        name: 'Kombine Sabit İhtimalli',
        info: 'Bir koşunun birincisini tahmin ederek o at üzerinde oynanan bahistir. Ganyan - Sabit ihtimalli bahis türünde kupon iptal edilemez ve eküri kuralları geçerli değildir.',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isFob: true,
        isCombine: true,
    },
    1890: {
        id: 1890,
        available: true,
        column: 4,
        subType: 4,
        columnLabel: 'Koşu',
        name: 'Kombine Sabit İhtimalli (S)',
        info: 'Bir koşunun birincisini tahmin ederek o at üzerinde oynanan bahistir. Ganyan - Sabit ihtimalli bahis türünde kupon iptal edilemez ve eküri kuralları geçerli değildir.',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isFob: true,
        isCombine: true,
    },
    1884: {
        id: 1884,
        available: true,
        column: 2,
        subType: 4,
        horseCount: 2,
        columnLabel: 'At',
        name: 'İkili - Sabit ihtimalli',
        prefix: '2li',
        info: 'Bir koşunun birincisini tahmin ederek o at üzerinde oynanan bahistir. Ganyan - Sabit ihtimalli bahis türünde kupon iptal edilemez ve eküri kuralları geçerli değildir.',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isFob: true,
        isFobPairPick: true,
        isSelectable: true,
    },
    1885: {
        id: 1885,
        available: true,
        column: 2,
        subType: 4,
        horseCount: 2,
        columnLabel: 'At',
        name: 'Sıralı İkili - Sabit ihtimalli',
        prefix: 'S. 2li',
        suffix: 'EX',
        info: 'Bir koşunun birincisini tahmin ederek o at üzerinde oynanan bahistir. Ganyan - Sabit ihtimalli bahis türünde kupon iptal edilemez ve eküri kuralları geçerli değildir.',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isFob: true,
        isFobPairPick: true,
        isSelectable: true,
    },
    1886: {
        id: 1886,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        name: 'İlk 2 - Sabit ihtimalli',
        prefix: 'İlk 2',
        suffix: 'T2',
        info: '',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isFob: true,
        isSelectable: true,
    },
    1887: {
        id: 1887,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        name: 'İlk 3 - Sabit ihtimalli',
        prefix: 'İlk 3',
        suffix: 'T3',
        info: '',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isFob: true,
        isSelectable: true,
    },
    1888: {
        id: 1888,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        name: 'İlk 4 - Sabit ihtimalli',
        prefix: 'İlk 4',
        suffix: 'T4',
        info: '',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isFob: true,
        isSelectable: true,
    },
    1889: {
        id: 1889,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        name: 'Ganyan - Uzun Vadeli',
        prefix: 'UV',
        info: '',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isLongterm: true,
        isSelectable: true,
    },
    1891: {
      id: 1891,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        name: 'Kim Geçer',
        prefix: 'KG',
        info: '',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isFob: true,
        isHeadToHead: true,
        isSelectable: true,
    },
    1892: {
        id: 1892,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        name: 'Favori Hariç',
        prefix: 'FH',
        suffix: 'WW',
        info: '',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        price: 1,
        isFob: true,
        isFavoriteExcluded: true,
        isSelectable: true,
    },
    0: {
        id: 0,
        available: true,
        column: 21,
        subType: 21,
        columnLabel: 'Koşu',
        price: 1,
        name: 'Gelecek Program',
        info: '',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isPlaceholder: true,
        isSelectable: true,
    },
    1: {
        isLegChain: true,
        id: 1,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        price: 1,
        name: 'Ganyan',
        info: 'Bir koşunun birincisini tahmin ederek o at üzerinde oynanan bahistir.',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isStablemateWins: true,
        isSelectable: true,
    },
    2: {
        id: 2,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        price: 1,
        name: 'Plase',
        info: 'En az 7 atın iştirak edeceği bir koşuda bir atın birinci veya ikinci geleceğini tahmin ederek o at veya atlar üzerinde oynanan bahistir.',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isSelectable: true,
    },
    4: {
        id: 4,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        price: 1,
        name: 'Ganyan & Plase',
        info: 'Ganyan ve plase oyunlarının aynı kuponda oynandığı oyun türüdür. Koşu sonucuna göre Ganyan ve/veya Plase ödemesi yapılır. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isSelectable: true,
        doublesBetCount: true,
    },
    8: {
        id: 8,
        available: true,
        column: 2,
        subType: 1,
        columnLabel: 'At',
        price: 1,
        name: 'Sıralı ikili Bahis',
        shortName: 'Sıralı ikili',
        info: 'En az 4 atın iştirak edeceği bir koşuda, birinci ve ikinci gelecek atı sırasıyla tahmin ederek o atlar üzerine oynanan bahistir. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isOrdered: true,
        isCompletable: true,
        isSelectable: true,
        winnerRule: "ordered",
    },
    9: {
        id: 9,
        available: false,
        column: 2,
        columnLabel: 'At',
        price: 1,
        name: 'Sıralı ikili Bahis (Komple)',
        shortName: "Sıralı ikili (K)",
        isOrdered: true,
        isSelectable: true,
        winnerRule: "ordered",
    },
    50: {
        id: 50,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        horseCount: 2,
        price: 1,
        name: 'Sıralı ikili (Virgüllü)',
        shortName: 'Sıralı ikili (V)',
        info: 'En az 4 atın iştirak edeceği bir koşuda, birinci ve ikinci gelecek atı sırasıyla tahmin ederek o atlar üzerine oynanan bahistir. Virgüllü oyun tipinde kazanma şartı; yazılan atların kupon onay sayfasında soldan sağa gösterildiği şekilde yarışı bitirmesidir. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isCommaType: true,
        isCompletable: true,
        isSelectable: true,
        subtractsMirroredPairs: true,
        winnerRule: "set",
    },
    10: {
        id: 10,
        available: true,
        column: 2,
        subType: 1,
        columnLabel: 'At',
        price: 1,
        name: 'İkili Bahis',
        info: 'En az 7 atın iştirak edeceği bir koşuda, birinci ve ikinciyi tahmin ederek, o atlar üzerine oynanan bahistir. Birinci ve ikinci sıralamanın değişmesi halinde de kazanç sağlanır. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isOrdered: true,
        isSelectable: true,
        subtractsMirroredPairs: true,
        winnerRule: "ordered",
    },
    11: {
        id: 11,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'At',
        price: 1,
        name: 'İkili Bahis (Tek Kolon)',
        info: 'En az 7 atın iştirak edeceği bir koşuda, birinci ve ikinciyi tahmin ederek, o atlar üzerine sıralamadan bağımsız tek kolonda seçim yaparak oynanan bahistir. Birinci ve ikinci sıralamanın değişmesi halinde de kazanç sağlanır. ',
        horseCount: 2,
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isSingleColumn: true,
        isSelectable: true,
        winnerRule: "set",
    },
    14: {
        isLegChain: true,
        id: 14,
        available: true,
        column: 2,
        subType: 2,
        columnLabel: 'Koşu',
        price: 1,
        name: 'Çifte Bahis',
        info: 'Birbiri ardına yapılan iki koşunun birincilerini tahmin ederek o atlar üzerine oynanan bahistir. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isStablemateWins: true,
        isAGFCondition: true,
        isSelectable: true,
    },
    15: {
        isLegChain: true,
        id: 15,
        available: true,
        column: 3,
        subType: 3,
        columnLabel: 'Ayak',
        price: 2,
        name: '3\'lü Ganyan',
        info: 'Birbiri ardına yapılan üç koşunun birincilerini tahmin ederek o atlar üzerine oynanan bahistir. . 3\'lü ganyanda da oyun tutarı her ayakta oynanan at sayıları toplamlarının birbirleri ile ve çıkan rakam da oyunun birim fiyatıyla çarpılarak bulunur. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isStablemateWins: true,
        isAGFCondition: true,
        isSelectable: true,
    },
    16: {
        isLegChain: true,
        id: 16,
        available: true,
        column: 4,
        subType: 4,
        columnLabel: 'Ayak',
        price: 1.75,
        name: '4\'lü Ganyan',
        info: 'Birbiri ardına yapılan dört koşunun birincilerini bulmak amacıyla oynanan oyundur. 4\'lü ganyanda da oyun tutarı her ayakta oynanan at sayıları toplamlarının birbirleri ile ve çıkan rakam da oyunun birim fiyatıyla çarpılarak bulunur. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isStablemateWins: true,
        isAGFCondition: true,
        isSelectable: true,
    },
    17: {
        isLegChain: true,
        id: 17,
        available: true,
        column: 5,
        subType: 5,
        columnLabel: 'Ayak',
        price: 1.5,
        name: '5\'li Ganyan',
        info: 'Birbiri ardına yapılan beş koşunun birincilerini bulmak amacıyla oynanan oyundur. 5\'li ganyanda da oyun tutarı her ayakta oynanan at sayıları toplamlarının birbirleri ile ve çıkan rakam da oyunun birim fiyatıyla çarpılarak bulunur.',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isStablemateWins: true,
        isAGFCondition: true,
        isSelectable: true,
    },
    18: {
        isLegChain: true,
        id: 18,
        available: true,
        column: 6,
        subType: 6,
        columnLabel: 'Ayak',
        price: 1,
        name: "6'lı Ganyan",
        info: 'Birbiri ardına yapılan altı koşunun birincilerini bulmak amacıyla oynanan oyundur. 6\'lı ganyanda oyun tutarı her ayağa yazılan at sayılarının toplamlarının birbirleri ile çıkan rakamında oyun birim fiyatıyla çarpılmasıyla bulunur. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isStablemateWins: true,
        isAGFCondition: true,
        isSelectable: true,
        isSecondSixCapable: true,
    },
    20: {
        isLegChain: true,
        id: 20,
        available: true,
        column: 7,
        subType: 7,
        columnLabel: 'Ayak',
        price: 2,
        name: "7'li Ganyan",
        info: 'Birbiri ardına yapılan altı koşunun birincilerini bulmak amacıyla oynanan oyundur. 7\'li ganyanda oyun tutarı her ayağa yazılan at sayılarının toplamlarının birbirleri ile çıkan rakamında oyun birim fiyatıyla çarpılmasıyla bulunur. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isStablemateWins: true,
        isAGFCondition: true,
        isSelectable: true,
    },
    19: {
        isLegChain: true,
        id: 19,
        available: true,
        column: 7,
        subType: 7,
        columnLabel: 'Ayak',
        price: 2,
        name: '7\'li Plase',
        info: 'Birbiri ardına yapılan yedi koşuda birinci veya ikinci gelecek atları tahmin ederek o atlar üzerine oynanan bahistir. Üzerine oynanan atın birinci veya ikinci gelmesi sonucu değiştirmez ve eşit kazanç sağlar. Aynı ayakta hem birinci hem ikinci gelen atları ihtiva eden bilet her iki at için de ayrı ayrı kazançlı sayılır. 7 koşunun birincilerini içeren bir bilet ile ikincilerini içeren diğer bir biletin kazanç tutarı arasında bir fark olmayacaktır. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isStablemateWins: true,
        isAGFCondition: true,
        isSelectable: true,
    },
    47: {
        id: 47,
        available: true,
        column: 2,
        subType: 1,
        columnLabel: 'At',
        price: 2,
        name: 'Plase İkili',
        info: 'Bir koşuda, ilk üç dereceye girecek farklı derecelere ait iki atı tahmin ederek o atlar üzerine oynanan bahistir. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isOrdered: true,
        isSelectable: true,
        subtractsMirroredPairs: true,
        winnerRule: "ordered",
        topNOverride: 3,
    },
    48: {
        id: 48,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'At',
        price: 2,
        name: 'Plase İkili (Tek Kolon)',
        info: 'Bir koşuda, ilk üç dereceye girecek farklı derecelere ait iki atı tahmin ederek sıralamadan bağımsız tek kolonda seçim yaparak o atlar üzerine oynanan bahistir. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isSingleColumn: true,
        isSelectable: true,
        winnerRule: "set",
    },
    51: {
        id: 51,
        available: true,
        column: 3,
        subType: 1,
        columnLabel: 'At',
        price: 2,
        name: 'Sıralı Üçlü Bahis',
        info: 'Bir koşuda birinci, ikinci ve üçüncü gelecek atları sırasıyla tahmin ederek o atlar üzerine oynanan bahistir. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isOrdered: true,
        isCompletable: true,
        isSelectable: true,
        winnerRule: "ordered",
    },
    52: {
        id: 52,
        available: false,
        column: 3,
        subType: 1,
        horseCount: 3,
        columnLabel: 'At',
        price: 2,
        name: 'Sıralı Üçlü Bahis (K)',
        shortName: 'Sıralı Üçlü (K)',
        isOrdered: true,
        isSelectable: true,
        winnerRule: "ordered",
    },
    53: {
        id: 53,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        horseCount: 3,
        price: 2,
        name: 'Sıralı Üçlü (Virgüllü)',
        shortName: 'Sıralı Üçlü (V)',
        info: 'Bir koşuda birinci, ikinci ve üçüncü gelecek atları sırasıyla tahmin ederek o atlar üzerine oynanan bahistir. Virgüllü oyun tipinde kazanma şartı; yazılan atların kupon onay sayfasında soldan sağa gösterildiği şekilde yarışı bitirmesidir. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isCommaType: true,
        isCompletable: true,
        isSelectable: true,
        winnerRule: "set",
    },
    54: {
        id: 54,
        available: true,
        column: 4,
        subType: 1,
        columnLabel: 'At',
        price: 1.5,
        name: 'Tabela Bahis',
        info: 'Bir koşuda birinci, ikinci, üçüncü ve dördüncü gelecek atları yarışın bitiriş sırasına göre veya sırasız bulmak amacıyla oynanan bir oyundur. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isOrdered: true,
        isCompletable: true,
        isSelectable: true,
        winnerRule: "ordered",
    },
    55: {
        id: 55,
        available: false,
        column: 4,
        horseCount: 4,
        columnLabel: 'At',
        price: 1.5,
        name: 'Tabela Bahis (Komple)',
        shortName: 'Tabela Bahis (K)',
        isSelectable: true,
        winnerRule: "ordered",
    },
    56: {
        id: 56,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        horseCount: 4,
        price: 1.5,
        name: 'Tabela Bahis (Virgüllü)',
        shortName: 'Tabela Bahis (V)',
        info: 'Bir koşuda, birinci, ikinci, üçüncü ve dördüncü gelecek atları sıralı veya sırasız olarak tahmin ederek o atlar üzerine oynanan bahistir. Virgüllü oyun tipinde kazanma şartı; yazılan atların kupon onay sayfasında soldan sağa gösterildiği şekilde yarışı bitirmesidir. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isCommaType: true,
        isCompletable: true,
        isSelectable: true,
        winnerRule: "set",
    },
    61: {
        id: 61,
        available: true,
        column: 5,
        subType: 1,
        columnLabel: 'At',
        price: 1.25,
        name: 'Sıralı Beşli',
        info: 'Bir koşuda, birinci, ikinci, üçüncü, dördüncü ve beşinci gelecek atları sırasıyla tahmin ederek o atlar üzerine oynanan bahistir. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isOrdered: true,
        isCompletable: true,
        isSelectable: true,
        winnerRule: "ordered",
    },
    62: {
        id: 62,
        available: false,
        column: 5,
        subType: 1,
        horseCount: 5,
        columnLabel: 'At',
        price: 1.25,
        name: 'Sıralı Beşli (Komple)',
        shortName: 'Sıralı Beşli (K)',
        isOrdered: true,
        isSelectable: true,
        winnerRule: "ordered",
    },
    63: {
        id: 63,
        available: true,
        column: 1,
        subType: 1,
        columnLabel: 'Koşu',
        horseCount: 5,
        price: 1.25,
        name: 'Sıralı Beşli (Virgüllü)',
        shortName: 'Sıralı Beşli (V)',
        info: 'Bir koşuda, birinci, ikinci, üçüncü, dördüncü ve beşinci gelecek atları sırasıyla tahmin ederek o atlar üzerine oynanan bahistir. Virgüllü oyun tipinde kazanma şartı; yazılan atların kupon onay sayfasında soldan sağa gösterildiği şekilde yarışı bitirmesidir. ',
        maxCouponAmount: 12000,
        minCouponAmount: 20,
        isCommaType: true,
        isCompletable: true,
        isSelectable: true,
        winnerRule: "set",
    },
};

export const bettingTypes: BettingType[] = Object.values(BettingTypesMap);

// Kupon gönderiminde bahis türü DEĞER olarak yazılıyor (dallanma değil), o yüzden bayrak değil
// isimli sabit gerekiyor. Örn. FOB kombine kuponu 1883, sistemli kombine 1890 olarak gider.
export const BettingTypeIds = {
    placeholder: 0,
    closingOdds: 1882,
    combine: 1883,
    combineSystem: 1890,
    longterm: 1889,
    headToHead: 1891,
} as const;
